import {
  ChangeDetectorRef,
  Component,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  OnInit,
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { AuthService } from "src/app/auth/services/auth.service";
import { ManageStaffService } from "src/app/hr-management/services/manage-staff.service";
import {
  NavigationStart,
  Router,
  Event,
} from "@angular/router";
import { environment } from "src/environments/environment";
import * as socketIo from "socket.io-client";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { ComponentsService } from "../services/components.service";
import { CustomNotificationComponent } from "src/app/shared/custom-notification/custom-notification.component";
// import html2canvas from "html2canvas";
import { MessageService } from "primeng/api";
import { MembershipService } from "src/app/membership/services/membership.service";
// import { IssueTrackingService } from 'src/app/issue-tracking/services/issue-tracking.service';
declare var $: any;

@Component({
  selector: "app-side-navbar",
  templateUrl: "./side-navbar.component.html",
  styleUrls: ["./side-navbar.component.css"],
  providers: [MessageService],
})
export class SideNavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("snav") snav;
  mobileQuery: MediaQueryList;
  canAccessMyAppointments: boolean;
  canAccessMyTasks: boolean;
  canAccessMemberships: boolean;
  canAccessEmails: boolean;
  canComposeEmail: boolean;
  canViewSentEmails: boolean;
  canViewEmailTemplate: boolean;
  canAccessHrManagement: boolean;
  canAccessStaff: boolean;
  canAccessStaffSchedule: boolean;
  canAccessStaffRota: boolean;
  canAccessPatients: boolean;
  canAccessReferralsMenu: boolean;
  canAccessConfiguration: boolean;
  canViewPatientImportFileList: boolean;
  canAccessPermissions: boolean;
  canAccessPatientFileConfiguration: boolean;
  canAccessRoles: boolean;
  CanAccessCompliance: boolean;
  CanAccessPracticeConfiguration: boolean;
  private _mobileQueryListener: () => void;
  IsMemberPrivilagePlan = false;
  currentUrl;
  showFullMenu = true;
  socketStaff;
  version = environment.Version;
  socket;
  msgs = [];
  referralBadgeCount;
  appointmentPendingCount;
  patientBadgeCount;
  subscription: Subscription;
  MembershipPatientLinkID;
  // CQC
  CanAccessCQCTemplates;
  CanAccessCQC: boolean;
  CanAccessOurPolicies: boolean;
  CanAccessCQCUpcomingReviews: boolean;
  CanAccessMyAppointments: boolean;
  logoImage = environment.logoImage;
  smallLogo = environment.smallLogo;
  CanAccessPractices: boolean;
  CanAccessReferralManagement: boolean;
  CanViewPractices: boolean;
  canAccessInbox: boolean;
  CanAccessServerSettings: boolean;
  CanAccessEmailSettings: boolean;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public auth: AuthService,
    private manageStaffService: ManageStaffService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private cookiesService: CookieService,
    private membershipService: MembershipService,
    private componentService: ComponentsService // private issueTrackService: IssueTrackingService
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        window.scroll(0, 0);
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
        if (
          this.currentUrl.trim() === "membership-privilage-form" ||
          this.currentUrl.trim().split("?")[0] === "membership-privilage-form"
        ) {
          this.IsMemberPrivilagePlan = true;
        } else {
          this.IsMemberPrivilagePlan = false;
        }
      }
    });

    this.subscription = auth.pendingAppts$.subscribe(() => {
      this.getCount();
    });

    this.subscription = auth.newReferral$.subscribe(() => {
      this.getCount();
    });

    this.subscription = auth.newPatient$.subscribe(() => {
      this.getCount();
    });

    this.subscription = auth.loginStatus$.subscribe(() => {
      if (!auth.isLoggedIn()) {
        window.location.reload();
      } else {
        this.checkPermissions();
        this.snav.toggle();
      }
    });
  }

  ngOnInit() {

    this.changeDetectorRef.detectChanges();

    let ref = this;
    this.socketStaff = socketIo.connect(environment.configSocketUrlStaff);
    this.socketStaff.on("connect", () => {
      this.auth.setSocketConnection(this.socketStaff);
      this.goOnline();
      this.cookiesService.set("LoginStatus", "1");

      ref.auth
        .updateLoginStatusForStaff(this.auth.staffId, 1, this.socketStaff.id)
        .subscribe(() => { });
    });

    this.socketStaff.on("AppointmentNotification", (msg) => {
      this.openSnackBar(msg);
      this.auth.pendingAppointments();
    });

    this.socketStaff.on("AppointmentNewNotification", (msg) => {
      msg = JSON.parse(msg);
      this.openSnackBar(
        'A new appointment has been booked by Patient "' +
        msg.PatientName +
        '" with "' +
        msg.StaffName +
        '" on "' +
        msg.AppointmentDate +
        '" at "' +
        msg.AppointmentStartTime +
        '".  This appointment can be accessed on   My Tasks -> Pending Appointments for further processing.  Please Click ok to take you to that tab.'
      );
    });

    this.socketStaff.on("AppointmentPMSAdd", () => {
      this.auth.pendingAppointments();
    });

    this.socketStaff.on("ReferalAssignComplete", () => {
      this.auth.newReferrals();
    });

    this.socketStaff.on("ViewRota", () => {
      this.openSnackBar(
        "A new rota is now available to view.  Please click ok to view the rota."
      );
    });

    this.socketStaff.on("IsLoggedIn", () => {
      this._snackBar.open(
        "You have logged in to a another system. So your session here has expired.",
        "",
        {
          duration: 5000,
          panelClass: ["red-background", "font2", "text-white"],
          horizontalPosition: "right",
          verticalPosition: "top",
        }
      );
      setTimeout(() => {
        this._snackBar.dismiss();
        this.showFullMenu = true;
        localStorage.clear();
        this.auth.loginStatusChanges();
        this.router.navigate(["auth", "login"]);
      }, 5000);
    });

    this.socketStaff.on("NewReferral", () => {
      this.auth.newReferrals();
      this.openSnackBar(
        "A new referral has been added from the website.  Please click ok to take you to the referrals."
      );
    });

    this.socketStaff.on("NewPatient", (msg) => {
      this.auth.newPatients();
      this.openSnackBar(
        "A new Patient has been registered from the website with Name " +
        msg.PatientName +
        " . Please click ok to take you to the patient."
      );
    });


    // var interval = 3 * 60 * 1000
    // setInterval(() => {
    //   this.socketStaff.emit('CheckNewEmail', 'info')
    // }, interval)

    // this.socketStaff.on("NewEmailNotify", (info) => {
    //   var multipleEmails = []
    //   if (info.result && info.result.length > 0) {
    //     info.result.forEach(element => {
    //       if (parseInt(element.NewEmailCount) > 0) {
    //         multipleEmails.push(element)
    //       }
    //     });

    //     if (multipleEmails && multipleEmails.length > 1) {
    //       this._snackBar.open(
    //         "Many emails recieved in multiple inboxes", "",
    //         {
    //           horizontalPosition: "end",
    //           verticalPosition: "top",
    //           duration: 3000,
    //           panelClass: ["pink-background", "font2", "text-white"],
    //         }
    //       );
    //     } else if (multipleEmails && multipleEmails.length === 1) {
    //       this._snackBar.open(
    //         "New email recieved in " + multipleEmails[0].Email + " ", "",
    //         {
    //           horizontalPosition: "end",
    //           verticalPosition: "top",
    //           duration: 3000,
    //           panelClass: ["pink-background", "font2", "text-white"],
    //         }
    //       );
    //     }
    //   }
    // });

    this.auth.getSocketConnection().subscribe((res) => {
      if (res) {
        this.socketStaff = res.text;
      }
    });
  }



  getCount() {
    this.componentService
      .GetNewAppointmentsAndReferralCount()
      .subscribe((res) => {
        if (res["success"]) {
          this.referralBadgeCount = res["data"][0].NewReferralCount;
          this.appointmentPendingCount = res["data"][0].NewAppointmentCount;
          this.patientBadgeCount = res["data"][0].NewPatientCount;
        }
      });
  }

  openSnackBar(message: string) {
    // this._snackBar.open(message, action, {
    //   duration: 216000,
    //   horizontalPosition: 'center',
    //   verticalPosition: 'top'
    // });
    // this.customNotificationComponent.msg=message;
    // this.auth.sendMessage(message)
    this._snackBar.openFromComponent(CustomNotificationComponent, {
      data: message,
      duration: 216000,
      panelClass: ["pink-background", "font2", "text-white"],
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  goOnline() {
    var data = {
      name: this.auth.staffName,
      staffId: this.auth.staffId,
      socketId: this.socketStaff.id,
    };
    this.socketStaff.emit("GoOnline", data);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit() {
    this.getCount();
  }

  toggle() {
    if (this.snav) {
      this.showFullMenu = !this.showFullMenu;
      if (this.showFullMenu) {
        $(".mat-drawer-inner-container").removeClass("activeClass");
        $(".mat-drawer-content").removeClass("activeClass");
        $(".mat-drawer-content").removeClass("activeClass");
      } else {
        $(".mat-drawer-inner-container").addClass("activeClass");
        $(".mat-drawer-content").addClass("activeClass");
        $(".mat-drawer-content").addClass("activeClass");
      }
    }
  }

  checkPermissions() {
    if (this.auth.isLoggedIn()) {
      this.canAccessMemberships =
        this.manageStaffService.getStoredStaffRolePermissions("Membership");
      this.canAccessMyAppointments =
        this.manageStaffService.getStoredStaffRolePermissions(
          "My Appointments"
        );
      this.canAccessMyTasks =
        this.manageStaffService.getStoredStaffRolePermissions("My Tasks");
      this.canAccessEmails =
        this.manageStaffService.getStoredStaffRolePermissions("Emails");
      this.canViewSentEmails =
        this.manageStaffService.getStoredStaffRolePermissions(
          "View Sent Emails"
        );
      this.canComposeEmail =
        this.manageStaffService.getStoredStaffRolePermissions("Compose Emails");
      this.canViewEmailTemplate =
        this.manageStaffService.getStoredStaffRolePermissions(
          "View Email Templates"
        );
      this.canAccessHrManagement =
        this.manageStaffService.getStoredStaffRolePermissions("HR Management");
      this.canAccessStaff =
        this.manageStaffService.getStoredStaffRolePermissions("Staff");
      this.canAccessStaffSchedule =
        this.manageStaffService.getStoredStaffRolePermissions("Staff Schedule");
      this.canAccessStaffRota =
        this.manageStaffService.getStoredStaffRolePermissions("Staff Rota");
      this.canAccessPatients =
        this.manageStaffService.getStoredStaffRolePermissions("Patients");
      this.canAccessReferralsMenu =
        this.manageStaffService.getStoredStaffRolePermissions("Referrals Menu");
      this.canAccessConfiguration =
        this.manageStaffService.getStoredStaffRolePermissions("Configuration");
      this.canViewPatientImportFileList =
        this.manageStaffService.getStoredStaffRolePermissions(
          "View Patient Import File List"
        );
      this.canAccessPermissions =
        this.manageStaffService.getStoredStaffRolePermissions("Permissions");
      this.canAccessPatientFileConfiguration =
        this.manageStaffService.getStoredStaffRolePermissions(
          "Patient File Configuration"
        );
      this.canAccessRoles =
        this.manageStaffService.getStoredStaffRolePermissions("Roles");
      this.CanAccessCompliance =
        this.manageStaffService.getStoredStaffRolePermissions("Compliance");
      this.CanAccessPracticeConfiguration =
        this.manageStaffService.getStoredStaffRolePermissions(
          "Practice Configuration"
        );
      this.CanAccessCQCTemplates =
        this.manageStaffService.getStoredStaffRolePermissions("CQC Template");
      this.CanAccessCQC =
        this.manageStaffService.getStoredStaffRolePermissions("CQC Compliance");
      this.CanAccessOurPolicies =
        this.manageStaffService.getStoredStaffRolePermissions("Our Policies");
      this.CanAccessCQCUpcomingReviews =
        this.manageStaffService.getStoredStaffRolePermissions(
          "Upcoming Policy Reviews"
        );
      this.CanAccessMyAppointments =
        this.manageStaffService.getStoredStaffRolePermissions(
          "My Appointments"
        );
      this.CanAccessReferralManagement =
        this.manageStaffService.getStoredStaffRolePermissions(
          "Referral Management"
        );
      this.CanAccessPractices =
        this.manageStaffService.getStoredStaffRolePermissions("Practices");
      this.CanViewPractices =
        this.manageStaffService.getStoredStaffRolePermissions("View Practices");

      // inbox
      this.canAccessInbox =
        this.manageStaffService.getStoredStaffRolePermissions("Inbox");
      this.CanAccessServerSettings =
        this.manageStaffService.getStoredStaffRolePermissions(
          "IMAP Server Settings"
        );
      this.CanAccessEmailSettings =
        this.manageStaffService.getStoredStaffRolePermissions("Email Settings");
    }
  }

  logout() {
    this.auth
      .updateLoginStatusForStaff(this.auth.staffId, 0, this.socketStaff.id)
      .subscribe((res) => {
        if (res) {
          this.showFullMenu = true;
          localStorage.clear();
          this.auth.loginStatusChanges();
          this.router.navigate(["auth", "login"]);
        }
      });
  }

  viewPendingAppointments() {
    this.router.navigate(["my-task", { tab: "Pending Appointments" }]);
  }

  GetPatients(){
  //  this.router.navigate(['/']).then(() => { this.router.navigate(["/patients/patients" ]); }) 
  //   this.router.ngOnDestroy();
  // alert(window.location)
   if(window.location.href.includes("patients/patients"))
      window.location.replace("patients/patients");
   else
      this.router.navigate(["patients/patients"]);
  //  {window.location.reload();}
    //this.router.navigate(["patients/patients"]);
   // window.location.replace("patients/patients");   
  }
  GetNewPatients(){
    if(window.location.href.includes("patients/patients"))
      window.location.replace("patients/patients?onlyNew=true");   
    else
      this.router.navigate(["patients/patients" , {onlyNew: true }]);
   // window.location.replace("patients/patients?onlyNew=true");   
  // this.router.navigate(["patients/patients" , {onlyNew: true }]);
  //  // this.router.ngOnDestroy();
  //   alert(this.router.onSameUrlNavigation);
  //   if(window.location.href.includes("patients/patients"))
  //   {window.location.reload();}
  //   this.router.navigate(["patients/patients" , {onlyNew: true }]);
  //   //window.location.reload();
  //let newRouterLink = 'patients/patients';

  //this.router.navigate(['/']).then(() => { this.router.navigate(["/patients/patients" , 'new' ]); }) 
 //this.router.navigate(['/']).then(() => { this.router.navigate(["patients/patients/new" ]); })   
}
  
  
  InsertActivityLog() {
    if (this.MembershipPatientLinkID) {
      this.membershipService
        .InsertMembershipNotes(
          localStorage.getItem("LogData"),
          this.MembershipPatientLinkID
        )
        .subscribe(
          (res) => {
            if (res["success"]) {
              localStorage.removeItem("LogData");
            } else {
            }
          },
          (err) => { }
        );
    }
  }

  // screenCapture() {
  //   let ref = this
  //   html2canvas(document.body).then(function (canvas) {
  //     canvas.toBlob(function (blob) {
  //       var formdata = new FormData()
  //       formdata.append('files', blob, 'file1.png')
  //       ref.issueTrackService.setScreenShot(formdata);
  //       ref.router.navigate(['issue-tracker', 'issue-tracking-form']);
  //     });
  //     ref.issueTrackService.setBlobImage(canvas.toDataURL())
  //   });
  // }

  // viewIssueList(){
  //   this.router.navigate(['issue-tracker','issue-tracking'])
  // }
}
